import {useLayoutEffect, useSyncExternalStore} from 'react'

const registrations = new Map<string, Map<string, number>>()
const listeners = new Set<() => void>()

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function emitChange() {
  for (const listener of listeners) listener()
}

export function useRegisterBackgroundActivity(sessionId: string, taskIds: readonly string[]) {
  useLayoutEffect(() => {
    if (taskIds.length === 0) return

    const sessionRegistrations = registrations.get(sessionId) ?? new Map<string, number>()
    registrations.set(sessionId, sessionRegistrations)
    for (const taskId of taskIds) sessionRegistrations.set(taskId, (sessionRegistrations.get(taskId) ?? 0) + 1)
    emitChange()

    return () => {
      for (const taskId of taskIds) {
        const count = sessionRegistrations.get(taskId) ?? 0
        if (count <= 1) sessionRegistrations.delete(taskId)
        else sessionRegistrations.set(taskId, count - 1)
      }
      if (sessionRegistrations.size === 0) registrations.delete(sessionId)
      emitChange()
    }
  }, [sessionId, taskIds])
}

export function useBackgroundActivityTaskPresent(sessionId: string, taskId: string | undefined) {
  return useSyncExternalStore(
    subscribe,
    () => Boolean(taskId && registrations.get(sessionId)?.has(taskId)),
    () => false,
  )
}
